// frontend/src/askos/PyqPracticeCard.js
//
// PYQ bank + attempts now have a real backend — shows live accuracy stats.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPyqStats } from '../api/pyqApi';

const PyqPracticeCard = ({ slug }) => {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);

    useEffect(() => {
        getPyqStats(slug).then(setStats).catch(() => setStats(null));
    }, [slug]);

    return (
        <article className="panel pyq-card">
            <div className="pyq-icon">▤</div>
            <h3>PYQ Practice</h3>
            {stats && stats.attempted > 0 ? (
                <p>{stats.attempted} attempted · {stats.accuracy_pct}% accuracy</p>
            ) : (
                <p>Practice previous-year questions by topic, year &amp; paper.</p>
            )}
            <button type="button" onClick={() => navigate('/samkalp-ias/pyq-practice')}>Start Practicing</button>
        </article>
    );
};

export default PyqPracticeCard;
